// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2xffU","selected":"Chip_selected__18oEy"};